import { api } from './client';
export async function getFeed(params) {
    const qs = new URLSearchParams();
    if (params?.date)
        qs.set('date', params.date);
    if (params?.from)
        qs.set('from', params.from);
    if (params?.cityId)
        qs.set('cityId', String(params.cityId));
    const query = qs.toString();
    return api(`/api/beacons/feed${query ? `?${query}` : ''}`);
}
export async function createBeacon(data) {
    return api('/api/beacons', {
        method: 'POST',
        body: JSON.stringify(data),
    });
}
export async function respondToBeacon(beaconId) {
    await api(`/api/beacons/${beaconId}/respond`, { method: 'POST' });
}
export async function acceptResponse(beaconId, responseId) {
    await api(`/api/beacons/${beaconId}/responses/${responseId}/accept`, { method: 'POST' });
}
export async function withdrawResponse(beaconId) {
    await api(`/api/beacons/${beaconId}/withdraw`, { method: 'POST' });
}
export async function getMyBeacons() {
    return api('/api/beacons/mine');
}
export async function deleteBeacon(id) {
    await api(`/api/beacons/${id}`, { method: 'DELETE' });
}
